var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGStoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 70,
    viewBox: "0 0 235 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5660_44282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.295 0H8.70485C3.89729 0 0 3.91786 0 8.75078V61.2492C0 66.0821 3.89729 70 8.70485 70H226.295C231.103 70 235 66.0821 235 61.2492V8.75078C235 3.91786 231.103 0 226.295 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.295 1.40037C230.326 1.40037 233.607 4.69903 233.607 8.75078V61.2492C233.607 65.301 230.326 68.5996 226.295 68.5996H8.70485C4.67437 68.5996 1.39302 65.301 1.39302 61.2492V8.75078C1.39302 4.69903 4.67437 1.40037 8.70485 1.40037H226.295ZM226.295 0H8.70485C3.91904 0 0 3.93972 0 8.75078V61.2492C0 66.0603 3.91904 70 8.70485 70H226.295C231.081 70 235 66.0603 235 61.2492V8.75078C235 3.93972 231.087 0 226.295 0Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5413 17.925C82.5413 19.3939 82.1079 20.5577 81.2412 21.4291C80.2567 22.4622 78.9814 22.985 77.4026 22.985C75.8238 22.985 74.6104 22.4622 73.5579 21.4104C72.5053 20.3586 71.9729 19.0578 71.9729 17.5018C71.9729 15.9458 72.4992 14.645 73.5579 13.5932C74.6104 12.5414 75.8919 12.0186 77.4026 12.0186C78.1517 12.0186 78.8637 12.1679 79.5448 12.4605C80.2258 12.753 80.7706 13.1451 81.1792 13.6305L80.2629 14.5517C79.5695 13.7239 78.6161 13.3069 77.4026 13.3069C76.3006 13.3069 75.3533 13.6928 74.5484 14.4708C73.7436 15.2487 73.3474 16.257 73.3474 17.5018C73.3474 18.7466 73.7498 19.7548 74.5484 20.5328C75.3533 21.3108 76.3006 21.6967 77.4026 21.6967C78.5665 21.6967 79.5386 21.3046 80.3187 20.5266C80.8263 20.0162 81.1173 19.3067 81.1916 18.398H77.3964V17.1346H82.4546C82.5042 17.4084 82.5289 17.6698 82.5289 17.925H82.5413Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5651 13.5374H85.8103V16.8671H90.1008V18.1306H85.8103V21.4604H90.5651V22.7487H84.4668V12.249H90.5651V13.5374Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2239 22.7487H94.8804V13.5374H91.9644V12.249H99.14V13.5374H96.2239V22.7487Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.334 22.7487V12.249H105.678V22.7487H104.334Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.634 22.7487H110.29V13.5374H107.374V12.249H114.55V13.5374H111.634V22.7487Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.133 21.3917C127.106 22.456 125.83 22.985 124.301 22.985C122.772 22.985 121.496 22.456 120.475 21.3917C119.447 20.3337 118.939 19.0329 118.939 17.5018C118.939 15.9707 119.453 14.6699 120.475 13.6119C121.503 12.5476 122.778 12.0186 124.301 12.0186C125.824 12.0186 127.093 12.5538 128.127 13.6181C129.155 14.6824 129.675 15.9769 129.675 17.5018C129.675 19.0266 129.161 20.3337 128.14 21.3917H128.133ZM121.465 20.5142C122.239 21.2984 123.187 21.6967 124.301 21.6967C125.415 21.6967 126.369 21.3046 127.137 20.5142C127.911 19.7299 128.301 18.7217 128.301 17.5018C128.301 16.2819 127.911 15.2736 127.137 14.4894C126.363 13.7052 125.415 13.3069 124.301 13.3069C123.187 13.3069 122.239 13.699 121.465 14.4894C120.692 15.2736 120.308 16.2819 120.308 17.5018C120.308 18.7217 120.698 19.7299 121.465 20.5142Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.557 22.7487V12.249H133.192L138.268 20.4148H138.324L138.268 18.392V12.249H139.612V22.7487H138.213L132.901 14.1847H132.845L132.901 16.2074V22.7487H131.557Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.605 38.0651C114.513 38.0651 111.176 41.1957 111.176 45.5089C111.176 49.822 114.513 52.9527 118.605 52.9527C122.698 52.9527 126.035 49.7971 126.035 45.5089C126.035 41.2206 122.698 38.0651 118.605 38.0651ZM118.605 50.0212C116.364 50.0212 114.426 48.1603 114.426 45.5089C114.426 42.8575 116.364 40.9966 118.605 40.9966C120.846 40.9966 122.784 42.8264 122.784 45.5089C122.784 48.1914 120.846 50.0212 118.605 50.0212ZM102.39 38.0651C98.2979 38.0651 94.9609 41.1957 94.9609 45.5089C94.9609 49.822 98.2979 52.9527 102.39 52.9527C106.483 52.9527 109.82 49.7971 109.82 45.5089C109.82 41.2206 106.483 38.0651 102.39 38.0651ZM102.39 50.0212C100.149 50.0212 98.2113 48.1603 98.2113 45.5089C98.2113 42.8575 100.149 40.9966 102.39 40.9966C104.632 40.9966 106.569 42.8264 106.569 45.5089C106.569 48.1914 104.632 50.0212 102.39 50.0212ZM83.1047 40.3493V43.5048H90.6208C90.3979 45.2786 89.8098 46.5794 88.912 47.4819C87.8162 48.5835 86.1074 49.7909 83.1047 49.7909C78.4798 49.7909 74.858 46.0441 74.858 41.3887C74.858 36.7332 78.4736 32.9864 83.1047 32.9864C85.5997 32.9864 87.4262 33.976 88.7696 35.2395L90.9861 33.0113C89.1102 31.2064 86.6089 29.8247 83.1047 29.8247C76.7649 29.8247 71.4404 35.0092 71.4404 41.3825C71.4404 47.7557 76.7711 52.9402 83.1047 52.9402C86.5284 52.9402 89.104 51.8137 91.1223 49.6976C93.1964 47.6126 93.8403 44.6811 93.8403 42.3098C93.8403 41.5754 93.7845 40.9032 93.6731 40.3368H83.0985L83.1047 40.3493ZM161.975 42.8015C161.355 41.1397 159.48 38.0651 155.635 38.0651C151.79 38.0651 148.651 41.0837 148.651 45.5089C148.651 49.6789 151.79 52.9527 156 52.9527C159.393 52.9527 161.355 50.8677 162.173 49.654L159.647 47.9611C158.805 49.1997 157.653 50.0212 156 50.0212C154.347 50.0212 153.164 49.2619 152.409 47.7682L162.309 43.6542L161.975 42.8077V42.8015ZM151.877 45.2848C151.79 42.4094 154.093 40.9406 155.746 40.9406C157.034 40.9406 158.13 41.5878 158.495 42.5214L151.877 45.2848ZM143.828 52.5045H147.079V30.6214H143.828V52.4983V52.5045ZM138.497 39.7331H138.386C137.655 38.8618 136.256 38.0714 134.486 38.0714C130.783 38.0714 127.39 41.3389 127.39 45.54C127.39 49.7411 130.783 52.9527 134.486 52.9527C136.25 52.9527 137.655 52.1622 138.386 51.2598H138.497V52.3303C138.497 55.1808 136.981 56.6994 134.541 56.6994C132.548 56.6994 131.316 55.2617 130.814 54.0481L127.979 55.2306C128.79 57.2036 130.95 59.6309 134.541 59.6309C138.355 59.6309 141.581 57.3778 141.581 51.8759V38.5132H138.497V39.7269V39.7331ZM134.77 50.0212C132.529 50.0212 130.647 48.1354 130.647 45.54C130.647 42.9446 132.529 41.0028 134.77 41.0028C137.012 41.0028 138.727 42.9198 138.727 45.54C138.727 48.1603 136.987 50.0212 134.77 50.0212ZM177.211 30.6276H169.429V52.5045H172.679V44.2143H177.217C180.821 44.2143 184.356 41.5941 184.356 37.4178C184.356 33.2416 180.814 30.6214 177.217 30.6214L177.211 30.6276ZM177.298 41.1708H172.679V33.6711H177.298C179.725 33.6711 181.105 35.6938 181.105 37.4178C181.105 39.1419 179.725 41.1646 177.298 41.1646V41.1708ZM197.37 38.0278C195.017 38.0278 192.584 39.0672 191.575 41.3762L194.46 42.5837C195.073 41.3762 196.224 40.9779 197.425 40.9779C199.103 40.9779 200.812 41.9924 200.843 43.7911V44.0152C200.255 43.6791 198.998 43.1687 197.456 43.1687C194.348 43.1687 191.185 44.8865 191.185 48.0918C191.185 51.017 193.729 52.9029 196.59 52.9029C198.775 52.9029 199.976 51.9195 200.732 50.7618H200.843V52.4485H203.976V44.0587C203.976 40.175 201.091 38.0091 197.37 38.0091V38.0278ZM196.98 50.015C195.915 50.015 194.429 49.4797 194.429 48.1603C194.429 46.4736 196.274 45.8263 197.871 45.8263C199.301 45.8263 199.97 46.1375 200.837 46.5607C200.583 48.5897 198.849 50.0212 196.974 50.0212L196.98 50.015ZM215.405 38.5008L211.684 47.986H211.572L207.709 38.5008H204.211L210.006 51.7577L206.7 59.133H210.087L219.02 38.5008H215.411H215.405ZM186.145 52.4983H189.395V30.6214H186.145V52.4983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.165 13.1884C17.6573 13.7299 17.3602 14.5639 17.3602 15.6469V54.347C17.3602 55.4299 17.6573 56.2639 18.165 56.8054L18.295 56.9299L39.859 35.2521V34.7417L18.295 13.064L18.165 13.1884Z",
    fill: "url(#paint0_linear_5660_44282)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0471 42.4846L39.8591 35.2524V34.742L47.0471 27.5161L47.208 27.6095L55.7272 32.4765C58.1603 33.8645 58.1603 36.1424 55.7272 37.5303L47.208 42.3974L47.0471 42.4908V42.4846Z",
    fill: "url(#paint1_linear_5660_44282)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2142 42.391L39.8591 34.9971L18.165 56.8118C18.9699 57.6644 20.2886 57.7703 21.7807 56.9176L47.208 42.391",
    fill: "url(#paint2_linear_5660_44282)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2142 27.6092L21.7807 13.0827C20.2886 12.23 18.9637 12.3358 18.165 13.1885L39.8591 34.997L47.2142 27.603V27.6092Z",
    fill: "url(#paint3_linear_5660_44282)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M47.0532 42.229L21.7869 56.6622C20.3753 57.4713 19.1123 57.4153 18.3012 56.6809L18.1712 56.8116L18.3012 56.936C19.1123 57.6705 20.3753 57.7265 21.7869 56.9174L47.2142 42.3908L47.0532 42.229Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M18.165 56.5566C17.6573 56.0151 17.3602 55.1811 17.3602 54.0981V54.3533C17.3602 55.4363 17.6573 56.2703 18.165 56.8118L18.295 56.6811L18.165 56.5566Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M55.7271 37.2688L47.0471 42.2292L47.208 42.391L55.7271 37.524C56.9406 36.8269 57.5536 35.912 57.5536 34.9971C57.4483 35.8248 56.8292 36.6402 55.7271 37.2688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M21.7807 13.3379L55.7271 32.7253C56.8292 33.3539 57.4483 34.1692 57.5535 34.997C57.5535 34.0821 56.9468 33.1672 55.7271 32.4701L21.7807 13.0827C19.3475 11.6948 17.3602 12.8462 17.3602 15.6469V15.9021C17.3602 13.1014 19.3475 11.9437 21.7807 13.3379Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5660_44282",
    x1: 37.946,
    y1: 15.2423,
    x2: 8.58206,
    y2: 44.4583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5660_44282",
    x1: 58.8971,
    y1: 35.0034,
    x2: 16.7782,
    y2: 35.0034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5660_44282",
    x1: 43.2147,
    y1: 39.0177,
    x2: 3.39483,
    y2: 78.6348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5660_44282",
    x1: 12.7044,
    y1: 0.311303,
    x2: 30.4858,
    y2: 17.9994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5660_44282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 235,
    height: 70,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGStoreIcon);
export default __webpack_public_path__ + "static/media/g-store-icon.97935e1da289e26b2743e7d7a79f433e.svg";
export { ForwardRef as ReactComponent };